(function () {
  if (customElements.get('accordion-jump-nav')) {
    return;
  }

  function mainContentRoot() {
    return document.getElementById('main-content') || document.querySelector('main[role="main"]') || document.body;
  }

  function isDisplayed(el) {
    if (!el) {
      return false;
    }
    if (el.offsetParent === null) {
      var s = window.getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden' || s.opacity === '0') {
        return false;
      }
      if (el.getBoundingClientRect().height === 0 && el.getBoundingClientRect().width === 0) {
        return false;
      }
    }
    return true;
  }

  function titleFromTrigger(trigger) {
    var titleWrap = trigger.querySelector('.accordion-title');
    if (!titleWrap) {
      return '';
    }
    var clone = titleWrap.cloneNode(true);
    clone.querySelectorAll('img').forEach(function (img) {
      img.remove();
    });
    return (clone.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function queryTriggers(root, linkScope) {
    var scope = (linkScope || 'accordion').trim();
    var list = [];
    if (scope === 'all') {
      list = Array.prototype.slice.call(root.querySelectorAll('util-accordion .accordion > button.accordion-trigger[id]'));
    } else {
      var sectionClasses = scope === 'accordion-richtext' ? ['type-accordion', 'type-richtext'] : ['type-accordion'];
      sectionClasses.forEach(function (cls) {
        root.querySelectorAll('section.' + cls + ' util-accordion .accordion > button.accordion-trigger[id]').forEach(function (btn) {
          list.push(btn);
        });
      });
    }
    return list;
  }

  function queryCategoryHeadings(root) {
    return Array.prototype.slice.call(root.querySelectorAll('section.type-accordion util-accordion .category-title:not(.hide)'));
  }

  class AccordionJumpNav extends HTMLElement {
    connectedCallback() {
      this.rowEl = this.querySelector('[data-jump-nav-list]');
      if (!this.rowEl) {
        return;
      }
      this.sep = typeof this.dataset.separator === 'string' ? this.dataset.separator : '|';
      this.linkScope = typeof this.dataset.linkScope === 'string' ? this.dataset.linkScope : 'accordion';
      this.linksFrom = typeof this.dataset.linksFrom === 'string' ? this.dataset.linksFrom : 'items';
      this.boundClick = this.onLinkClick.bind(this);
      this.addEventListener('click', this.boundClick);
      var debounce = window.$s && typeof $s.debounce === 'function' ? $s.debounce : function (fn, wait) {
        var t;
        return function () {
          clearTimeout(t);
          var args = arguments;
          t = setTimeout(function () {
            fn.apply(null, args);
          }, wait);
        };
      };
      this.debouncedBuild = debounce(this.build.bind(this), 120);
      this.build();
      var root = mainContentRoot();
      this._mo = new MutationObserver(this.debouncedBuild);
      this._mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-expanded'] });
      if (window.Shopify && Shopify.designMode) {
        this._onSectionLoad = this.debouncedBuild;
        document.addEventListener('shopify:section:load', this._onSectionLoad);
        document.addEventListener('shopify:section:unload', this._onSectionLoad);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.boundClick);
      if (this._mo) {
        this._mo.disconnect();
      }
      if (window.Shopify && Shopify.designMode && this._onSectionLoad) {
        document.removeEventListener('shopify:section:load', this._onSectionLoad);
        document.removeEventListener('shopify:section:unload', this._onSectionLoad);
      }
    }

    onLinkClick(e) {
      var a = e.target.closest && e.target.closest('a[data-jump-target]');
      if (!a || !this.contains(a)) {
        return;
      }
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) !== '#') {
        return;
      }
      var id = href.slice(1);
      var target = document.getElementById(id);
      if (!target) {
        return;
      }
      e.preventDefault();
      if (!isDisplayed(target)) {
        return;
      }
      var accordion = target.closest('.accordion');
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (accordion && !accordion.classList.contains('open')) {
        var openBtn = target.matches && target.matches('button.accordion-trigger') ? target : accordion.querySelector('button.accordion-trigger');
        if (openBtn) {
          openBtn.click();
        }
      }
      if (typeof target.focus === 'function') {
        try {
          target.focus({ preventScroll: true });
        } catch (err) {
          target.focus();
        }
      }
    }

    build() {
      if (!this.rowEl) {
        return;
      }
      var root = mainContentRoot();
      var seen = Object.create(null);
      this.rowEl.textContent = '';
      var count = 0;
      var useHeadings = this.linksFrom === 'headings';

      if (useHeadings) {
        var headings = queryCategoryHeadings(root);
        for (var h = 0; h < headings.length; h++) {
          var headingEl = headings[h];
          if (!headingEl.id || !isDisplayed(headingEl)) {
            continue;
          }
          var headingText = (headingEl.textContent || '').replace(/\s+/g, ' ').trim();
          if (!headingText || seen[headingEl.id]) {
            continue;
          }
          seen[headingEl.id] = true;
          if (count > 0) {
            var sepH = document.createElement('span');
            sepH.className = 'accordion-jump-nav-sep';
            sepH.setAttribute('aria-hidden', 'true');
            sepH.textContent = this.sep;
            this.rowEl.appendChild(sepH);
          }
          var linkH = document.createElement('a');
          linkH.className = 'accordion-jump-nav-link';
          linkH.href = '#' + headingEl.id;
          linkH.setAttribute('data-jump-target', '');
          linkH.textContent = headingText;
          this.rowEl.appendChild(linkH);
          count++;
        }
      } else {
        var triggers = queryTriggers(root, this.linkScope);
        for (var i = 0; i < triggers.length; i++) {
          var btn = triggers[i];
          var acc = btn.closest('.accordion');
          if (!acc || !isDisplayed(acc)) {
            continue;
          }
          var text = titleFromTrigger(btn);
          if (!text) {
            continue;
          }
          var bid = btn.id;
          if (!bid || seen[bid]) {
            continue;
          }
          seen[bid] = true;
          if (count > 0) {
            var sepSpan = document.createElement('span');
            sepSpan.className = 'accordion-jump-nav-sep';
            sepSpan.setAttribute('aria-hidden', 'true');
            sepSpan.textContent = this.sep;
            this.rowEl.appendChild(sepSpan);
          }
          var link = document.createElement('a');
          link.className = 'accordion-jump-nav-link';
          link.href = '#' + bid;
          link.setAttribute('data-jump-target', '');
          link.textContent = text;
          this.rowEl.appendChild(link);
          count++;
        }
      }
      this.classList.toggle('is-empty', count === 0);
    }
  }

  customElements.define('accordion-jump-nav', AccordionJumpNav);
})();
